import {
  ArrowLeft,
  MoreHorizontal,
  LayoutGrid,
} from 'lucide-react';
import { useRef } from 'react';

type Props = {
  name: string;
  email: string;
  organization?: string;
  month: string;
  busy: boolean;
  backLabel: string;
  canDownload: boolean;
  onBack: () => void;
  onMonth: (month: string) => void;
  onCoverage: () => void;
  onRefresh: () => void;
  onDownload: () => void;
  onNotifications: () => void;
};

export default function ReviewContextHeader(props: Props) {
  const menu = useRef<HTMLDetailsElement>(null);
  const run = (action: () => void) => {
    if (menu.current) menu.current.open = false;
    action();
  };
  return (
    <header className="review-context-header">
      <div className="review-context-person">
        <button
          className="review-back"
          disabled={props.busy}
          onClick={props.onBack}
          aria-label={props.backLabel}
          title={props.backLabel}
        >
          <ArrowLeft size={18} aria-hidden="true" />
          <span>Volver</span>
        </button>
        <span className="review-context-divider" aria-hidden="true" />
        <h1 title={props.name}>{props.name}</h1>
      </div>
      <div className="review-context-tools">
        <label className="review-period-control">
          <input
            aria-label="Periodo consultado"
            type="month"
            disabled={props.busy}
            value={props.month}
            onChange={(event) => props.onMonth(event.target.value)}
          />
        </label>
        <button
          aria-label="Cobertura anual"
          title="Cobertura anual"
          className="review-coverage"
          disabled={props.busy}
          onClick={props.onCoverage}
        >
          <LayoutGrid size={16} aria-hidden="true" />
          <span>Cobertura anual</span>
        </button>
        <details
          ref={menu}
          className="review-context-menu"
          onKeyDown={(event) => {
            if (event.key === 'Escape' && menu.current) {
              menu.current.open = false;
              menu.current.querySelector('summary')?.focus();
            }
          }}
        >
          <summary aria-label="Más opciones" title="Más opciones">
            <MoreHorizontal size={20} aria-hidden="true" />
          </summary>
          <div className="review-context-menu-content">
            <p className="review-context-contact">
              <strong>{props.name}</strong>
              <span>{props.email}</span>
              <span>{props.organization || 'Sin organización'}</span>
            </p>
            <button disabled={props.busy} onClick={() => run(props.onRefresh)}>
              Actualizar expediente
            </button>
            {props.canDownload && (
              <button
                disabled={props.busy}
                onClick={() => run(props.onDownload)}
              >
                Descargar ZIP
              </button>
            )}
            <button onClick={() => run(props.onNotifications)}>
              Historial de notificaciones
            </button>
          </div>
        </details>
      </div>
    </header>
  );
}
